// Referral API.
// Mirrors the axios+token pattern used by api/billing.ts
// (token in localStorage 'cleveroo_token' with 'accessToken' fallback).

import axios from 'axios';
import { ReferralData, API_ENDPOINTS } from '../types/api';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

function authHeaders(): Record<string, string> {
  const token =
    localStorage.getItem('cleveroo_token') ||
    localStorage.getItem('accessToken') ||
    '';
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/**
 * Fetch the authenticated user's referral code, link, stats and credits.
 */
export async function getMyReferral(): Promise<ReferralData> {
  const res = await axios.get(`${API_BASE_URL}${API_ENDPOINTS.REFERRALS.ME}`, {
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
  });
  return res.data?.data as ReferralData;
}

/**
 * Record an outbound invite event. Best-effort — callers should not
 * block the user flow on this completing or succeeding.
 * @param channel  e.g. 'copy' | 'share'
 */
export async function trackInvite(channel?: string): Promise<void> {
  await axios.post(
    `${API_BASE_URL}${API_ENDPOINTS.REFERRALS.TRACK_INVITE}`,
    channel ? { channel } : {},
    { headers: { 'Content-Type': 'application/json', ...authHeaders() } }
  );
}
